<template>
  <div style="width: 100%" class="pa-2">
    <div class="btn-group justify-between align-center">
      <span class="ml-2">Icon</span>
      <v-spacer></v-spacer>
      <v-btn icon small tile color="error" @click.stop="deleteIcon(item.id)">
        <v-icon>mdi-delete-outline</v-icon>
      </v-btn>
    </div>
    <v-divider class="mx-1"></v-divider>
    <div class="d-flex justify-start">
      <v-avatar color="#F4F7FA" size="80" class="mt-3">
        <v-img
          class="mt-2"
          :src="item.patch"
          style="height: 80px; width: 80px"
        />
      </v-avatar>
      <div class="pl-6 pt-3">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              style="font-size: 16px; max-width: 250px"
              >{{
                item.name && item.name.length > 30
                  ? item.name.substring(0, 30) + '...'
                  : item.name
              }}</div
            >
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
        <div class="pt-1 d-flex" style="color: gray">
          <div>Định dạng: {{ item.file_type }}</div>
          <v-spacer></v-spacer>
          <div>{{ getFileSize(item.size) }}</div>
        </div>
        <div class="d-flex pt-3">
          <div class="btn-group">
            <base-button
              small
              :bindIcon="{ small: true }"
              @click.stop="editIcon(item)"
              type-action="update"
              color="#00ED64"
              no-icon
            >
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: () => ({}),
  computed: {
    item() {
      return this.value
    },
  },
  methods: {
    deleteIcon(id) {
      this.$emit('delete-icon', id)
    },
    editIcon(item) {
      this.$emit('edit-icon', item)
    },
    getFileSize(size) {
      try {
        let sizeKb = size / 1024
        if (sizeKb < 1024) {
          return sizeKb.toFixed(1) + ' Kb'
        } else {
          return (sizeKb / 1024).toFixed(1) + ' Mb'
        }
      } catch (error) {
        return ''
      }
    },
  },
}
</script>

<style></style>
